module.exports = __webpack_public_path__ + "img/06.5689f0f2.png";